import React from 'react';
import RefreshButton from './RefreshButton';
import CloseModal from './CloseModal';
import InputField from './InputField';
import Dropdown from './Dropdown';
import BasicButton from './Buttons';
import Loader from './Loader';
import { UpDownArrow } from './IconButtons';
import Pagination from './Pagination';
import LazyImage from './LazyImage';
import { formatDate } from '../Constants/constant';

const PositionWiseData = ({rows, filter, usersOption, loading, loadingFilter, loadingClear, pagination, 
    onRefresh, onClose, onChangeFilter, onFilterClear, onFilter, onPositionCheck, onSort, onPositionSelect, onLimit, onPrev, onNext}) => {
    const handlePositionSelect = (event, val)=> {
        const syntheticEvent = {
        ...event,
        target: { ...event.target, value: val },
      };
        onPositionSelect?.(syntheticEvent)
    }
    return (
        <div className=' w-full h-screen  fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className=' relative h-[95vh] w-[95%]  lightBabyGreen rounded-2xl mx-10 px-2 py-4   '>
                <RefreshButton onClick={onRefresh} position='absolute' zIndex="20" />
                <CloseModal onClick={onClose} />
                <div className='h-full w-full  rounded-2xl overflow-y-scroll noScrollbar px-8 mb-4'>
                    {/* filter */}
                    <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl mb-3'>
                        <InputField id="fromDate" name="fromDate" type="date" label="From:"
                            value={filter?.fromDate}
                            onChange={onChangeFilter}
                        />
                        <InputField  id="toDate" name="toDate" type="date" label="To:"
                            value={filter?.toDate}
                            onChange={onChangeFilter}
                        />
                        <InputField  id="company" name="company" type="text" label="Company:"
                            placeholder="Enter Company"
                            value={filter?.company}
                            onChange={onChangeFilter}
                        />
                        <InputField  id="position" name="position" type="text" label="Position:"
                            placeholder="Enter Position"
                            value={filter?.position}
                            onChange={onChangeFilter}
                        />
                        <Dropdown id="recruiter" name="recruiter" label="Recruiter:"
                            onChange={onChangeFilter}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            placeholder={`Select Recruiter`}
                            value={filter?.recruiter}
                            options={usersOption}
                            search={true} // to enable search input
                            checkBox={true} // to enable checkbox
                            checkValue={filter?.isActive} // to make checkbox check and uncheck
                            onCheck={onPositionCheck} // to make changes in list of options onChange  
                        />
                        <div className="flex gap-3 col-span-1">
                            <div className=" flex flex-col">
                                <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                                <BasicButton onClick={onFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                                disabled={loading} loading={loadingFilter} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                            </div>
                            <div className=" flex flex-col">
                                <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                                <BasicButton onClick={onFilterClear} buttonName='Clear Filter' className="bg-red-700 text-nowrap" shadow={true}
                                disabled={loading} loading={loadingClear} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                            </div>
                        </div>
                    </div>
                    {
                        loading ?
                            <Loader/> :
                            Array.isArray(rows) && rows?.length >= 1 ?
                            <section className='tableWrapper'>
                                <div className='tableBody'>
                                    <table>
                                        <thead className='tableHead'>
                                            <tr className='text-left'>
                                                <th className='whitespace-nowrap text-center w-11' >Sr.No.</th>
                                                <th id='upload_date' className='whitespace-nowrap text-center cursor-pointer w-11' onClick={onSort} >
                                                    <div className='flex items-center gap-2 justify-center'>Date    
                                                        {filter?.orderBy === "upload_date" && filter?.orderDirection === "ASC" ?
                                                            <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                            filter?.orderBy === "upload_date" && filter?.orderDirection === "DESC" ?
                                                            <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                            <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                    </div>
                                                </th>
                                                <th id='company_name' className='cursor-pointer w-[35%]' onClick={onSort}>
                                                    <div className='flex items-center gap-2'>Company Name 
                                                        {filter?.orderBy === "company_name" && filter?.orderDirection === "ASC" ? 
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> : 
                                                        filter?.orderBy === "company_name" && filter?.orderDirection === "DESC" ? 
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}</div>
                                                </th>
                                                <th id='position' className='cursor-pointer w-[35%]' onClick={onSort}>
                                                    <div className='flex items-center gap-2'>Company Position 
                                                        {filter?.orderBy === "position" && filter?.orderDirection === "ASC" ? 
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> : 
                                                        filter?.orderBy === "position" && filter?.orderDirection === "ASC" ? 
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}</div>
                                                </th>
                                                <th className='whitespace-nowrap text-center'>Count</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tableBody '>
                                            {
                                                Array.isArray(rows) && rows?.map((val, idx) => {
                                                    return (
                                                        <>
                                                            {/* {val?.created_at?.split("T")[0] === sourceViewModal ? */}
                                                            <tr key={val?.id} id={val?.id} className='font-semibold text-sm text-left'>
                                                                <td className='whitespace-nowrap text-center'>{idx + 1}</td>
                                                                <td className='whitespace-nowrap text-center'>{val?.upload_date ? formatDate(val?.upload_date) : '--'}</td>
                                                                <td className=' hover:text-blue-700 cursor-pointer'
                                                                    onClick={(e)=> {handlePositionSelect(e, val)}}
                                                                >{val?.company_name}</td>
                                                                <td className=' hover:text-blue-700 cursor-pointer'
                                                                    onClick={(e)=> {handlePositionSelect(e, val)}}>{val?.position_name}</td>
                                                                <td className='whitespace-nowrap text-center'>{val?.candidate_count}</td>
                                                            </tr>
                                                            {/* : null} */}

                                                        </>

                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table >
                                </div>
                                <Pagination onLimitChange={onLimit} onPrevChange={onPrev} onNextChange={onNext} limit={pagination?.limit}
                                totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page} 
                                disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                                />
                            </section> :
                        <div className='navAnimation w-full flex flex-col justify-center items-center bg-white mt-5 py-5 mb-10 rounded-3xl '>
                            <LazyImage className=' w-[25%]' src="/img/addReports.png" alt="Not Found" />
                            <h1 className=' text-2xl font-bold'>Oops!! "<span className=' text-blue-950'>No Reports Found</span>"</h1>
                        </div>
                    }
                                        </div>
            </div>
        </div>
    );
}

export default PositionWiseData;
